module.exports = __webpack_public_path__ + "static/background-28f206bdfc31bfc68cbc15db00cbc172.jpg";